import React, { useState } from 'react';
import logo from '../../assets/OHM_1.png';
import './ResetNewPassword.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { api } from '../../Api-Endpoints/apiEndpoint';

const ResetNewPassword = () => {
  const navigate = useNavigate();
  const { email } = useParams();
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  console.log('Email from params:', email);
  const handleResetNewPasswordClick = () => {
    const { newPassword, confirmPassword } = formData;
    
    // Check if passwords match
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    // Check password strength (optional)
    if (newPassword.length < 6) {
      toast.error('Password must be at least 6 characters long');
      return;
    }

    // Create payload
    const payload = {
      email: email || '',
      password: newPassword,
    };    
    // Here you would typically make an API call to update the password
    // Example:
    api.patch('/user/update/user/password', payload)
      .then(response => {
        toast.success('Password updated successfully', {
  duration: 15000, // 15 seconds
});
        setFormData({ newPassword: '', confirmPassword: '' });
        navigate('/reset-new-password'); // Redirect to login page after
      })
      .catch(error => {
        toast.error(error.response?.data?.message || 'Failed to update password');
      });
  };

  return (
    <>
      <div className="loginSignUp">
        <div className="main">
          <div className="left">
            <div className="image">
              <img src={logo} alt="logo" />
            </div>
            <div className="heading-sighin">
              <p>Reset Password</p>
            </div>
            <div className="input-feild">
              <input 
                type="password" 
                name="newPassword"
                placeholder="New Password" 
                value={formData.newPassword}
                onChange={handleInputChange}
              />
              <input 
                type="password" 
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleInputChange}
              />
            </div>
            <div className="buttens">
              <button
                className="login-btn"
                onClick={handleResetNewPasswordClick}
              >
                Set Password
              </button>
            </div>
          </div>
          <div className="right">
            <div className="head-text-combine">
              <div className="heading-welcome">
                <p>Reset Your Password</p>
              </div>
              <div className="text-for-welcome">
              Please enter your new password in the box on the left and confirm it to update your account. <br />
                <br />
                Make sure to remember your new password for the next time you log in
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetNewPassword;
